import * as React from 'react'

import { useDropzone } from 'react-dropzone'
import { convertImage } from './utils'

interface Props {
  children: React.ReactNode
  onImageUploaded: (images: UploadImageIncidentRequest[]) => void
}

interface Data extends Blob {
  name: string
}

const ImagePicker = ({ children, onImageUploaded }: Props) => {
  const readFile = (file: Data) => {
    return new Promise<UploadImageIncidentRequest>((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () =>
        convertImage(reader.result as string, file.type).then((data) => resolve({ image: data, filename: file.name }))
      reader.onerror = () => reject('error')
      reader.onabort = () => reject('canceled')

      reader.readAsDataURL(file)
    })
  }

  const onDrop = (files: Data[]) => {
    Promise.all(files.map(readFile)).then(onImageUploaded)
  }

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: { 'image/png': ['.png'], 'image/jpeg': ['.jpg', '.jpeg'] },
  })

  return (
    <div {...getRootProps()} style={{ cursor: 'pointer' }}>
      <input {...getInputProps()} />
      {children}
    </div>
  )
}

export default ImagePicker
